import { render, staticRenderFns } from "./RolesCrudAdmin.vue?vue&type=template&id=03cd470b"
import script from "./RolesCrudAdmin.vue?vue&type=script&lang=js"
export * from "./RolesCrudAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports